import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SearchResult } from './search-result';

@Component({
  selector: 'app-results',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  templateUrl: './results.component.html',
})
export class ResultsComponent {
  public results = input.required<SearchResult[]>();
  public searchResultSelect = output<void>();
}
